var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPresales = function SvgPresales(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.669 40C202.656 40 210.698 46.96 215.67 56.9038C220.726 67.0152 222.46 80.0302 222.46 91.1789C222.46 102.328 220.726 115.343 215.67 125.454C210.698 135.398 202.656 142.358 189.669 142.358C183.065 142.358 177.925 140.55 173.871 137.619C169.785 134.665 166.638 130.449 164.258 125.409C159.465 115.26 158 102.236 158 91.1789C158 80.1152 159.431 67.092 164.205 56.9456C166.576 51.907 169.718 47.6932 173.809 44.7399C177.868 41.8097 183.025 40 189.669 40ZM190.091 139.092C196.302 139.092 201.348 137.082 205.335 133.718C209.267 130.4 212.031 125.885 213.98 121.035C217.861 111.381 218.777 99.7333 218.777 91.3182C218.777 82.973 217.861 71.3596 213.98 61.7224C212.03 56.8811 209.266 52.3706 205.334 49.055C201.348 45.6933 196.302 43.6833 190.091 43.6833C183.732 43.6833 178.618 45.6668 174.618 49.0329C170.673 52.3532 167.981 56.8731 166.129 61.7182C162.448 71.3487 161.827 82.9741 161.827 91.3182C161.827 99.6629 162.45 111.321 166.13 120.984C167.981 125.845 170.672 130.382 174.615 133.716C178.614 137.097 183.729 139.092 190.091 139.092Z",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M344.056 141.887C330.249 141.887 319.422 133.452 314.738 120.995H318.326C322.766 131.316 331.72 138.905 344.201 138.905C360.668 138.905 373.978 125.595 373.978 109.129C373.978 92.8456 360.706 79.2061 344.201 79.2061C339.891 79.2061 335.562 80.1961 331.381 81.3895C329.243 81.9595 327.359 82.4758 325.502 83.0881L334.032 38.5H374.17V42.069H344.017H339.8H339.795H337L336.36 44.9239L331.075 73.1079L330.015 78.7615L335.523 77.1047C338.091 76.3323 340.979 75.933 344.056 75.933C362.214 75.933 376.96 90.7885 376.96 108.983C376.96 127.159 362.232 141.887 344.056 141.887Z",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 137.905H145.458V142.452H84.5012L117.622 103.616L117.625 103.613L117.635 103.602L117.638 103.599L117.672 103.559L117.816 103.393L118.364 102.759C118.836 102.213 119.513 101.429 120.33 100.482C121.964 98.5865 124.16 96.0327 126.407 93.4C128.653 90.769 130.956 88.0523 132.801 85.8336C134.573 83.7034 136.097 81.8288 136.623 81.0174C138.626 77.9254 139.889 72.921 139.889 68.3984C139.889 54.0086 128.302 42.2516 113.742 42.2516C99.3399 42.2516 87.5951 53.9963 87.5951 68.3984C87.5951 71.0269 87.9689 73.4732 88.6683 75.8H84.4302C83.7326 73.3944 83.3389 71.052 83.3389 68.3984C83.3389 51.7459 97.0848 38 113.737 38C129.325 38 142.127 49.7217 143.864 64.9327L143.866 64.9479L143.868 64.9631C143.986 65.9132 143.991 67.1797 143.991 68.4031C143.991 75.471 141.592 81.9889 137.625 87.0261L98.5663 132.962L94.3631 137.905H100.852Z",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.852 137.905H301.458V142.452H240.501L273.622 103.616L273.625 103.613L273.635 103.602L273.638 103.599L273.672 103.559L273.816 103.393L274.364 102.759C274.836 102.213 275.513 101.429 276.33 100.482C277.964 98.5865 280.16 96.0327 282.407 93.4C284.653 90.769 286.956 88.0523 288.801 85.8336C290.573 83.7034 292.097 81.8288 292.623 81.0174C294.626 77.9254 295.889 72.921 295.889 68.3984C295.889 54.0085 284.302 42.2516 269.742 42.2516C255.34 42.2516 243.595 53.9962 243.595 68.3984C243.595 71.0271 243.969 73.4734 244.669 75.8H240.43C239.733 73.3945 239.339 71.052 239.339 68.3984C239.339 51.7459 253.085 38 269.737 38C285.325 38 298.127 49.7216 299.864 64.9327L299.866 64.9479L299.868 64.9631C299.986 65.9132 299.991 67.1796 299.991 68.4031C299.991 75.4708 297.593 81.9885 293.625 87.0256L254.566 132.962L250.363 137.905H256.852Z",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 379C57.35 379 57.35 416.3 94.7 416.3C132.05 416.3 132.05 379 169.4 379C206.75 379 206.75 416.3 244.1 416.3C281.45 416.3 281.45 379 318.8 379C356.15 379 356.15 416.3 393.5 416.3C430.85 416.3 430.9 379 468.25 379",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M442.352 346.1L473.852 316.45L486.552 316H53.7524C46.6024 316 43.1524 324.8 48.4024 329.65L65.5524 345.55",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384.952 252.703L381.552 240.603C373.402 211.553 346.852 191.453 316.652 191.453H129.902L129.352 252.703",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.902 191.453H33.6523",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9023 191.453L95.4023 252.703H372.552C395.602 252.703 417.052 264.503 429.402 283.953L445.652 309.503",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4023 252.703V309.503",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 285.5H373.203",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M350.954 285.5H139.504",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "44.51 44.51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.402 285.5H116.652",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M346.453 222.102H334.703",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M313.903 222.102H158.203",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "41.52 41.52"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.852 222.102H136.102",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPresales);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/presales.svg";